import script from "./TabbedVideoPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabbedVideoPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./TabbedVideoPlayer.vue?vue&type=style&index=0&id=112fe488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-112fe488"]])

export default __exports__